import { MESSAGE_LOAD_ERROR_TEXT } from '@zg-rentals/satellite-components';
import StringConstants from '../constants/StringConstants';

type GetLeadManagementMessageTextArgs = {
  isConversationBlockedByZillow: boolean;
  messageText?: string | null;
};

const getLeadManagementMessageText = ({
  isConversationBlockedByZillow,
  messageText,
}: GetLeadManagementMessageTextArgs): string => {
  if (isConversationBlockedByZillow) {
    return StringConstants.CONVERSATION_BLOCKED_BY_ZILLOW_TEXT;
  }

  return messageText ? messageText : MESSAGE_LOAD_ERROR_TEXT;
};

export default getLeadManagementMessageText;
